export function copyToClipboard (text) {
  return new Promise((resolve, reject) => {
    if (window.clipboardData && window.clipboardData.setData) {
      // IE specific code path to prevent textarea being shown while dialog is visible.
      resolve(window.clipboardData.setData('Text', text))
      return
    } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
      var textarea = document.createElement('textarea')
      textarea.textContent = text
      textarea.style.position = 'fixed'  // Prevent scrolling to bottom of page in MS Edge.
      document.body.appendChild(textarea)
      textarea.select()
      try {
        resolve(document.execCommand('copy'))  // Security exception may be thrown by some browsers.
      } catch (ex) {
        reject(new Error('Copy to clipboard failed'))
      } finally {
        document.body.removeChild(textarea)
      }

      return
    }

    reject(new Error('Copy to clipboard failed'))
  })
}

export function shareNativeCompatible () {
  return typeof window.navigator.share === 'function'
}

export function shareNative (data) {
  const mailto = () => {
    window.location.href = `
      mailto:
      ?subject=${window.encodeURIComponent(data.title)}
      &body=${window.encodeURIComponent(data.text)}%0D%0A${window.encodeURIComponent(data.url)}
    `
  }
  if (typeof window.navigator.share === 'function') {
    window.navigator.share(data).catch(mailto)
  } else {
    mailto()
  }
}
export function mailTo (data) {
  window.open(`mailto:?subject=${window.encodeURIComponent(data.title)}` +
    `&body=${window.encodeURIComponent(data.text)}%0D%0A${window.encodeURIComponent(data.url)}`, '_blank')
}



// WEBPACK FOOTER //
// ./src/helpers/browser.js